'use strict';
module.exports = require('../../full/instance/reduce');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/reduce.js
// module id = 598
// module chunks = 13